import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';

import { Nullable } from 'src/types/nullable.type';

import { AddStrongIcon, DeleteStrongIcon } from 'src/monet/icons';
import FileDropzone from 'src/common/FileDropzone';
import { Button } from 'src/common/button';
import { ShareLinkFieldType } from '../../../form/link-config-form.factory';

interface Props {
  logoUrl: Nullable<string>;
  onLogoFileUpload: (file: File) => void;
  onFieldChange: (payload: ShareLinkFieldType<unknown>) => void;
  isFetchingBrand: boolean;
}

const PersonalizatonLogoUpload = ({ logoUrl, onLogoFileUpload, onFieldChange, isFetchingBrand }: Props) => {
  const logoUploadRef = useRef<Nullable<HTMLInputElement>>(null);  

  const onLogoUploadClicked = () => {
    if (logoUploadRef.current) {
      logoUploadRef.current.value = '';
      if (logoUrl) {
        onFieldChange({ field: 'personalization_logo_url', value: '' });
        onFieldChange({ field: 'personalization_domain', value: '' });
      } else {
        logoUploadRef.current.click();
      }
    }
  };

  const onFilesUpdate = (files: Array<File>) => {
    if (files.length > 0) {
      const file = files[0];
      onLogoFileUpload && onLogoFileUpload(file);
    }
  };

  const buttonContent = logoUrl ? (
    <Button size='regular' variant='tertiary' icon={<DeleteStrongIcon />} label='Remove' />
  ) : (
    <Button
      size='regular'
      variant='tertiary'
      icon={<AddStrongIcon />}
      label='Upload'
      className={classNames({
        'invisible group-hover:visible': logoUrl,
        visible: !logoUrl,
      })}
    />
  );

  return (
    <div className='flex flex-col'>
      <div className='hidden'>
        <FileDropzone
          accept='image/*'
          type='file'
          className='file-dropzone'
          multiple={false}
          onFilesUpdate={onFilesUpdate}
          resetOnSuccess={true}
          dropzoneClasses={null}
          inputRef={logoUploadRef}
          disabled={isFetchingBrand}
        />
      </div>
      <div
        className='w-[112px] h-[112px] bg-bedrock-light-gray rounded-lg relative items-center justify-center cursor-pointer'
        onClick={onLogoUploadClicked}
      >
        <div className='w-full h-full relative group cursor-pointer'>
          {logoUrl && (
            <div className='absolute w-full h-full left-0 top-0 flex items-center justify-center transition-opacity opacity-100 group-hover:opacity-0'>
              <img src={logoUrl} alt='' className='block w-auto h-auto max-h-[50px] max-w-[50px]' />
            </div>
          )}          
          <div
            className={classNames(
              'absolute w-full h-full left-0 top-0 flex items-center justify-center transition-opacity',
              {
                'opacity-0 group-hover:opacity-100': logoUrl,
                'opacity-100': !logoUrl,
              }
            )}
          >
            {buttonContent}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalizatonLogoUpload;
